import { useEffect } from 'react';
import {
  useMutate,
  FirebaseAuthService,
} from '@kanda-libs/ks-frontend-services';

const ContainerComponent = ({}) => {
  const { mutate: logout } = useMutate(
    FirebaseAuthService.logout.bind(FirebaseAuthService),
  );

  useEffect(() => (logout as () => void)(), [logout]);

  return null;
};

ContainerComponent.displayName = 'Logout-container';

export default ContainerComponent;
